<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label v-if="label" :for="name">{{ label }}</label>
    <select @change="updateValue($event.target.value)" :name="name" :required="required" class="form-control">
      <option v-if="placeholder" value="" disabled>{{ placeholder }}</option>
      <option v-for="option in options" :value="option.val" :selected="value == option.val">
        {{ option.label }}
      </option>
    </select>
    <span v-if="error" class="help-block" v-html="error"></span>
  </div>
</template>

<script>
  export default{
    name: 'InputSelect',
    props: ['name', 'value', 'options', 'required', 'label', 'placeholder', 'error'],
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputSelect.vue?144ec267